import { DocumentActionsCell } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { fetchDocumentUrl } from "~/hooks/useDocumentsQuery"

type Props = {
  documentId: string
  documentName: string
}

export const CertificateRequestDocumentActions = ({
  documentId,
  documentName,
}: Props) => {
  const { t } = useTranslation("common")

  return (
    <DocumentActionsCell
      documentName={documentName}
      documentId={documentId}
      fetchDownloadUrl={() => fetchDocumentUrl(documentId, true)}
      fetchViewUrl={() => fetchDocumentUrl(documentId)}
      missingDocumentText={t("documentUpload.missingDocument")}
    />
  )
}
